import React from 'react';

function FilteringFilesContent() {
  return (
    <>
      <p>To prevent unnecessary files (like build artifacts or node_modules) from cluttering your workspace view, RepoPrompt provides powerful filtering options using ignore patterns.</p>
      
      <h3>Setting Up Ignore Patterns</h3>
      <ol>
        <li>Click the "Filters" button above the file tree panel</li>
        <li>The "Ignore Patterns" modal window will appear with two tabs</li>
      </ol>
      
      <h3>Global Default Patterns</h3>
      <p>These patterns apply to all workspaces in RepoPrompt:</p>
      <ol>
        <li>Click the "Global Default" tab in the Ignore Patterns modal</li>
        <li>Edit the patterns in the text area (RepoPrompt includes sensible defaults)</li>
        <li>Patterns follow <code>.gitignore</code> syntax</li>
        <li>Common patterns include: <code>node_modules/</code>, <code>*.log</code>, <code>.git/</code>, etc.</li>
      </ol>
      
      <h3>Local Folder Patterns</h3>
      <p>These patterns apply only to specific folders in your workspace:</p>
      <ol>
        <li>Click the "Local Folder" tab in the Ignore Patterns modal</li>
        <li>Select the specific folder within your workspace using the "Select Folder" dropdown</li>
        <li>Edit the patterns in the text area</li>
        <li>If a <code>.repo_ignore</code> file exists in that folder, its contents will be loaded automatically</li>
      </ol>
      
      <h3>Pattern Precedence</h3>
      <p>When determining which files to show or hide:</p>
      <ul>
        <li>Local folder patterns override global defaults</li>
        <li>More specific patterns take precedence over general ones</li>
      </ul>
      
      <p>After saving your filter changes, files matching the ignore patterns will be hidden from the file tree, reducing clutter and making it easier to find relevant files.</p>
      
      <div className="tip-box">
        <strong>Tip:</strong> You can create a <code>.repo_ignore</code> file in your project repository to share filtering rules with team members.
      </div>
    </>
  );
}

export default FilteringFilesContent;